<template>
  <v-container grid-list-sm>
    <v-layout row wrap>
      <masonry
        style="width: 100%;"
        :cols="{default: 2, 600: 1}"
        :gutter="2">
        <tcloud-comp no-animation>
          <template v-slot:title>Me e...</template>
          <v-card>
            <v-card-title primary-title>
              <div style="width: 100%;">
                <div class="headline">{{ settings.nome }}</div>
                <span>{{ settings.email }}</span>
              </div>
            </v-card-title>
            <v-card-text>
              <v-input
                :messages="['E\' necessario riautenticarsi \
                  per attivare la procedura di cambio password']">
                <v-btn
                  @click="activateChangePassword"
                  color="warning">Cambia password</v-btn>
              </v-input>
            </v-card-text>
          </v-card>
        </tcloud-comp>
        <tcloud-comp no-animation>
          <template v-slot:title>I miei locali</template>
          <v-card>
            <v-list>
              <v-list-tile
                color="primary"
                :key="index"
                v-for="(locale, index) in settings.locali">
                <v-list-tile-avatar>
                  <v-btn @click="toggleLocale(locale.id)" ripple icon color="primary">
                    <v-icon>
                      {{ localiAttivi.includes(locale.id) ?
                        'mdi-eye' :
                        'mdi-eye-off' }}</v-icon>
                  </v-btn>
                </v-list-tile-avatar>
                <v-list-tile-content >
                  <span class="headline">{{ locale.nome }}</span>
                </v-list-tile-content>
                <v-list-tile-action>
                  <div>
                    <v-menu
                      absolute
                      offset-y>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          :class="coloreLocale(locale.id)"
                          fab
                          small
                          flat
                          v-on="on"></v-btn>
                      </template>

                      <v-list class="colors">
                        <div
                          @click="setColor([locale.id, color])"
                          :class="['color', color]"
                          class="color"
                          :key="color"
                          v-for="color in colors"></div>
                      </v-list>
                    </v-menu>
                  </div>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
            <v-card-text>
              <v-switch
                :input-value="mostraCodiciArticolo"
                @change="setShowCodes"
                label="Mostra codici articolo"
              ></v-switch>
              <v-switch
                :input-value="mostraConcordati"
                @change="setShowConcordati"
                label="Mostra concordati"
              ></v-switch>
            </v-card-text>
          </v-card>
        </tcloud-comp>
        <tcloud-comp no-animation>
          <template v-slot:title>Report</template>
          <v-card>
            <v-card-text>
              <v-layout>
                <v-flex xs12>
                  <v-layout row>
                    <v-switch
                      v-model="localSettings.daily_report"
                      label="Invia report tramite Telegram"
                      persistent-hint
                      hint="Al raggiungimento di ciascuna soglia di incasso
                      verrà inviata una notifica tramite Telegram.
                      Si intende l'incasso a partire dall'ultima chiusura di cassa."
                    ></v-switch>
                    <v-dialog
                      v-model="showQrTelegram"
                      width="400">
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-show="localSettings.daily_report"
                          v-on="on"
                          icon>
                          <v-icon>mdi-qrcode-scan</v-icon>
                        </v-btn>
                      </template>

                      <v-card>
                        <v-card-title
                          class="headline"
                          primary-title
                        >
                          QR code Telegram
                        </v-card-title>

                        <v-card-text>
                          <v-img
                            style="margin: auto;"
                            width="300"
                            height="300"
                            v-if="qrImage"
                            :src="qrImage"
                          ></v-img>

                          <v-btn
                            target="_blank"
                            :disabled="!qrLink"
                            :href="qrLink"
                            block
                            color="primary"
                            dark>
                            Apri in Telegram
                          </v-btn>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="primary"
                            flat
                            @click="showQrTelegram = false">
                            Chiudi
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout v-if="localSettings.daily_report" wrap class="mt-2">
                <v-flex xs12 sm4>
                  <v-text-field
                    @click:append="remove('daily_report_th1')"
                    label="Soglia 1"
                    append-icon="mdi-minus"
                    type="number"
                    v-model="localSettings.daily_report_th1">
                    <template v-slot:prepend-inner>
                      <v-icon @click="add('daily_report_th1')">mdi-plus</v-icon>
                    </template>
                  </v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                    @click:append="remove('daily_report_th2')"
                    label="Soglia 2"
                    append-icon="mdi-minus"
                    type="number"
                    v-model="localSettings.daily_report_th2">
                    <template v-slot:prepend-inner>
                      <v-icon @click="add('daily_report_th2')">mdi-plus</v-icon>
                    </template>
                  </v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                    @click:append="remove('daily_report_th3')"
                    label="Soglia 3"
                    append-icon="mdi-minus"
                    type="number"
                    v-model="localSettings.daily_report_th3">
                    <template v-slot:prepend-inner>
                      <v-icon @click="add('daily_report_th3')">mdi-plus</v-icon>
                    </template>
                  </v-text-field>
                </v-flex>
              </v-layout>
              <v-text-field
                @blur="checkThenSave('extra_email')"
                label="Email secondaria per invio di report"
                single-line
                type="email"
                prepend-icon="mdi-email"
                v-model="localSettings.extra_email"
              ></v-text-field>
            </v-card-text>
          </v-card>
        </tcloud-comp>
        <tcloud-comp no-animation>
          <template v-slot:title>Sicurezza</template>
          <v-card>
            <v-card-title primary-title>
              <v-switch
                false-value="NRM"
                true-value="OSV"
                :input-value="['OSV', 'FOSV'].indexOf(modalita) !== -1 ? 'OSV' : 'NRM'"
                @click="e => promptLoginExt(e)"
                label="Modalità estesa"
              ></v-switch>
            </v-card-title>
          </v-card>
        </tcloud-comp>
      </masonry>
    </v-layout>
    <v-dialog
      content-class="login-dialog"
      v-model="loginExt"
      persistent
      max-width="290">
      <v-card>
        <v-form
          @submit.native="doExtLogin"
          ref="loginForm"
          v-model="formValid"
          lazy-validation>
          <v-card-text>
            <v-text-field
              autofocus
              v-model="loginForm.password"
              type="password"
              :rules="requiredRules"
              label="Password"
              required
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              type="submit"
              :loading="activatingExtMode"
              color="green darken-1" flat @click="doExtLogin">Attiva</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { setTimeout } from 'timers';

export default {
  name: 'profile',
  data() {
    return {
      localSettings: {},
      saveTimeout: null,
      showQrTelegram: false,
      qrImage: null,
      qrLink: null,
      showCode: false,
      loginExt: false,
      activatingExtMode: false,
      formValid: false,
      loginForm: {
        username: null,
        password: null,
      },
      requiredRules: [
        v => !!v || 'Campo obbligatorio',
      ],
    };
  },
  mounted() {
    this.localSettings = { ...this.settings.settings };
  },
  methods: {
    checkThenSave(path) {
      if (this.$get(this.localSettings, path) !== this.$get(this.settings, `settings.${path}`)) {
        // console.log(this.localSettings);
        this.saveSettings(this.localSettings);
      }
    },
    add(path) {
      this.localSettings[path] += 100;
    },
    remove(path) {
      if (this.localSettings[path] - 100 > 0) {
        this.localSettings[path] -= 100;
      }
    },
    promptLoginExt(e) {
      e.preventDefault();
      e.stopPropagation();
      if (this.modalita !== 'NRM') this.setModalitaEstesa('NRM');
      else this.loginExt = true;
    },
    async doExtLogin(e) {
      e.preventDefault();
      e.stopPropagation();
      if (this.$refs.loginForm.validate()) {
        this.activatingExtMode = true;
        await this.authModalitaEstesa(this.loginForm.password);
        this.activatingExtMode = false;
        this.loginExt = false;
        this.$refs.loginForm.reset();
      }
    },
  },
  watch: {
    localSettings: {
      handler() {
        if (this.saveTimeout) this.saveTimeout.close();
        this.saveTimeout = setTimeout(() => {
          this.saveSettings(this.localSettings);
        }, 3000);
      },
      deep: true,
    },
    async showQrTelegram(newV) {
      if (newV) {
        // console.log('LOAD TOKEN!');
        const { qr, link } = await this.loadQrTelegram();
        this.qrImage = qr;
        this.qrLink = link;
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.colors
  width 200px
  height 200px
  display flex
  flex-wrap wrap
  padding 0
  margin 0
  .color
    width 50px
    height 50px
    border 2px solid #fff
    cursor pointer
    &:hover
      opacity .8
</style>
